import React, { Component, PropTypes } from 'react';
import { TextField, FlatButton, Styles } from 'material-ui';
import MediaQuery from 'services/MediaQuery';
import MainMenu from 'components/Material/MainMenu';
import CoursioTheme from 'components/Material/Styles/CoursioTheme';
import AppSnackBar from 'components/AppSnackBar';
import MessagePortal from 'components/MessagePortal';
import DialogPortal from 'components/DialogPortal';
import { Dialog } from 'material-ui';
import { NotificationActions, AppActions } from 'actions';
import { Colors } from 'Css';
import { history } from 'helpers';
import i18n from 'oxygen-i18n';
import Helmet from 'react-helmet';
import moment from 'moment';

const navigatorData = [
  'appCodeName',
  'appName',
  'appMinorVersion',
  'cpuClass',
  'platform',
  // 'plugins',
  'opsProfile',
  'userProfile',
  'systemLanguage',
  'userLanguage',
  'appVersion',
  'userAgent',
  // 'onLine',
  'cookieEnabled'
  // 'mimeTypes',
];
const windowData = ['innerWidth', 'innerHeight'];

const locationData = [
  'host',
  'hostname',
  'href',
  'origin',
  'pathname',
  'port',
  'protocol'
];

const { ThemeManager } = Styles;

const css = oxygenCss({
  BODY: {
    backgroundColor: Colors.theme.Light.background
  },
  report: {
    '& H4': {
      fontWeight: 'bold',
      marginTop: '2em'
    },
    '& H3': {
      fontWeight: 'bold',
      marginBottom: '1em'
    }
  }
});

class App extends Component {
  static contextTypes = {
    getIntlMessage: PropTypes.func,
    muiTheme: PropTypes.object
  };

  static childContextTypes = {
    muiTheme: PropTypes.object,
    media: PropTypes.string,
    getIntlMessage: PropTypes.func
  };

  state = {
    media: MediaQuery.detect(),
    shouldSendBeDisabled: true
  };

  getChildContext() {
    return {
      muiTheme: ThemeManager.getMuiTheme(CoursioTheme),
      media: this.state.media,
      getIntlMessage: this.context.getIntlMessage
    };
  }

  componentDidMount() {
    this.handleResize = :: this.handleResize;
    this.handleContextMenu = :: this.handleContextMenu;
    window.addEventListener('resize', this.handleResize);
    if (__PRODUCTION__) {
      document.addEventListener('contextmenu', this.handleContextMenu);
    }
    // AuthActions.login();
    this.checkUnreadNotifications();
  }

  componentWillReceiveProps(nextProps) {
    const { params, location } = this.props;
    const { pathname } = location;
    if (params.hash) {
      return;
    }
    if (this.props.locale !== nextProps.locale) {
      const { locale } = nextProps;
      i18n.setLocale(locale.replace('_', '-'), locale.replace('_', '-'));
      moment.locale(locale.replace(/(_SE|_EN)/g, ''));
      this.forceUpdate();
    }
    if (!!nextProps.reportBug && !this.props.reportBug) {
      this.showReportBugDialog();
    } else if (!nextProps.reportBug && !!this.props.reportBug) {
      this.hideReportBugDialog();
    }

    if (nextProps.loggedIn && !this.props.loggedIn) {
      this.checkUnreadNotifications(true);
      const { query } = location;
      if (query && query.nextPath && query.nextPath.nextPath !== '/logout') {
        history.push(query.nextPath);
      }
    } else if (
      this.props.loggedIn &&
      !nextProps.loggedIn &&
      pathname !== '/login'
    ) {
      history.push('/login');
    } else if (
      this.props.loggedIn &&
      !nextProps.loggedIn &&
      pathname !== '/login'
    ) {
      history.replace('/login');
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('contextmenu', this.handleContextMenu);
    clearTimeout(this._timer);
  }

  onMenuChange = (event, key, payload) => {
    if (payload.route) {
      history.push(`/${payload.route}`);
    } else if (payload.action && this[payload.action]) {
      this[payload.action](payload);
      event.preventDefault();
    }
  }

  checkUnreadNotifications(force = false) {
    if (this.props.loggedIn || force) {
      NotificationActions.countUnreadNotifications();
      this._timer = setTimeout(() => {
        this.checkUnreadNotifications();
      }, 5 * 60 * 10000);
    }
  }

  handleResize() {
    const media = MediaQuery.detect();
    if (this.state.media !== media) {
      this.setState({ media });
    }
  }

  showReportBugDialog() {
    this.refs.bugReportDialog.show();
  }

  hideReportBugDialog() {
    this.refs.bugReportDialog.dismiss();
  }

  handleContextMenu(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  dismissBugReport() {
    AppActions.hideReportBugDialog();
  }

  submitBug() {
    const technicalData = {
      media: this.context.media,
      location: {}
    };
    const navigator = window.navigator || {};
    navigatorData.forEach(key => {
      technicalData[key] = navigator[key];
    });
    windowData.forEach(key => {
      technicalData[key] = window[key];
    });
    locationData.forEach(key => {
      technicalData.location[key] = window.location[key];
    });
    const userComment = this.refs.bugData.getValue();
    AppActions.reportBug(userComment, technicalData);
    this.dismissBugReport();
  }

  checkBugDataValidation() {
    const bugData = this.refs.bugData.getValue();
    const isValidBugData = bugData.trim().split(/\s+/).length;

    this.setState({shouldSendBeDisabled: !(isValidBugData >= 3)});
  }

  render() {
    let leftNav;
    const { loggedIn, message } = this.props;
    if (loggedIn) {
      // leftNav = <LeftNav nested={true} ref="leftNav" header={header} docked={false} menuItems={this.appMenuItems} onChange={this.onMenuChange} zDepth={0} onForceClose={this.forceCloseMenu}/>;
      leftNav = (
        <MainMenu
          closeOnRequestClose
          zIndex={101}
          initialOpen={false}
          onChange={this.onMenuChange}
        />
      );
    }
    const reportBugActions = [
      <FlatButton style={{marginRight: 10}} onTouchTap={this.dismissBugReport}
                  secondary={true} label={this.context.getIntlMessage('Cancel')} />,
      <FlatButton secondary={true} label={this.context.getIntlMessage('bug.reportTitle')}
                  ref={'submit'} disabled={this.state.shouldSendBeDisabled}
                  onTouchTap={this.submitBug.bind(this)}
      />
    ];

    const english = (
      <div className={css.report}>
        <h3>
          Frequently Asked Questions
        </h3>

        <h4>I have forgot my password.</h4>
        <p>Click the button that says “FORGOT YOUR PASSWORD” under the login-button to get an email sent to your email address with a link. Click the link to select a new password. If you can’t find the email, please make sure to look in the junk mail.</p>

        <h4>I have changed the password but it still doesn’t work.</h4>
        <p>Make sure that you type your email address and password manually when you’re trying to log in since webb browsers tend to save old passwords.</p>

        <h4>I have a problem seeing things, the course is lagging, the pages are empty, I can’t see the videos.</h4>
        <p>First, make sure that you are using Google Chrome when using Coursio, it is most compatible with our tool. Other platforms may cause technical issues when using Coursios tool e.g Explorer. </p>

        <h4>Do you have questions about the course content?</h4>
        <p>Please contact the course creator as Coursio can only help with technical issues.</p>

        <h4>My course has disappeared?</h4>
        <p>If your course have disappeared it is most likely because the access time for the course has expired. Before you buy the course there are information about how long the access time for the course is. You can also see the access time on your Dashboard on each individual course on the right corner. If you want to continue to read the course after the access time has expired, you will have to buy the course again.</p>

        <h4>How do I create an account?</h4>
        <p>When you purchase a course you will automatically be redirected to the page where you create an account. To get to this page you have to click the purchase-button for selected course.</p>

        <h4>When do I get access to the rest of the material in my course?</h4>
        <p>Sometimes the course creator chooses to release material in a course at different times. If you have questions regarding this, please contact the course creator since Coursio only can help with technical difficulties.</p>

        <h4>Is there a Coursio app that I can download?</h4>
        <p>Coursio does not have an app for the time being.</p>

        <h4>I am finished with my course but doesn’t get a diploma.</h4>
        <p>Some courses contain a diploma that the course reader can download when the course is finished. If you haven’t received your diploma it usually depends on that you haven’t completed all the momentums that is required. You can see if all of the momentums has been completed by looking at the index of the course. Next to every chapter title there is a circle, when you have completed the chapter the circle gets completely filled and checked off. If the course contains a Quiz, make sure that all of the questions are answered.</p>

        <h4>Can I undo my purchase?</h4>
        <p>You have the right to return your purchase within 14 days. If it’s within 14 days since purchase and you want to make a return, email us and we will cancel your purchase. </p>

        <h4>My invitation link has expired.</h4>
        <p>The invitation links are valid for 30 days after the email has been sent to you.
        If you have been invited to a course and your invitation link has expired, please contact the course creator and ask them to send you a new invitation.</p>

        <h4>Can I download the course material?</h4>
        <p>You can only download course material that the course creator has made downloadable in the form of downloadable files e.g pdf:s, excel files etc. Otherwise you can only get the information by reading the course in the platform.</p>

        <h4>I have received a gift code and want to use it, how?</h4>
        <p>If you have received a gift code to a course you click on this link → https://app.coursio.com/gift and fill out the code in the box. Then you will have the opportunity to create an account at Coursio or log in to your already existing account to take part of the course.</p>

        <h4>I want to change the email address connected to my Coursio account, how?</h4>
        <p>To change your email address you click on the Settings button in the main menu and scroll down to User Settings. When you have chosen your new email address you scroll down to the bottom at the page to save. You can also change your password under Change Password. Don’t forget to save!</p>

      </div>
    )

    return (
      <div
        style={{
          zIndex: 1,
          width: '100%',
          height: '100%',
          position: 'absolute',
          left: 0,
          top: 0
        }}
      >
        {this.props.children}
        <DialogPortal>{leftNav}</DialogPortal>
        <DialogPortal>
          <Dialog
            title={this.context.getIntlMessage('bug.report')}
            ref="bugReportDialog"
            onDismiss={this.dismissBugReport.bind(this)}
            actions={reportBugActions}
            autoDetectWindowHeight={true}
            autoScrollBodyContent={true}
          >
            {english}
            <TextField
              hintText={this.context.getIntlMessage('bug.describe')}
              onChange={() => this.checkBugDataValidation()}
              fullWidth
              multiLine
              rowsMax={8}
              ref="bugData"
              style={{
                marginTop: '2em'
              }}
            />
          </Dialog>
        </DialogPortal>
        <MessagePortal>
          <AppSnackBar {...message} />
        </MessagePortal>
        <Helmet title="Coursio 3" />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/js/components/App.js